import migration0 from "./migration0";
import disconnectMigration from "./disconnectMigration";
import { resetNews } from "store/actions/newsActions";

const migrations = {
  0: migration0,
  1: disconnectMigration,
  2: disconnectMigration,
  3: resetNews,
};

export default migrations;
